import { Faqs } from '@prisma/client';
import API_URL from '../apiconfig';
import axios from './api';
import { getApiErrorMessage } from './apiError';
import { toUpsertFaq } from '../helpers/faqs';
import { DraftFaq } from '../types/faqs';

function faqsPath(businessId: string) {
  return `${API_URL}/v1/booking-site/${businessId}/faqs`;
}

function toDraftFaq(row: Pick<Faqs, 'faqId' | 'header' | 'text'>): DraftFaq {
  return { id: row.faqId, header: row.header, text: row.text };
}

export async function fetchFaqs(businessId: string): Promise<DraftFaq[]> {
  try {
    const response = await axios.get(faqsPath(businessId));
    return (response?.data?.result ?? []).map(toDraftFaq);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Cannot get FAQs'), {
      cause: error,
    });
  }
}

export async function commitFaqs(
  businessId: string,
  faqs: DraftFaq[],
): Promise<DraftFaq[]> {
  try {
    const response = await axios.put(faqsPath(businessId), {
      faqs: faqs.map(toUpsertFaq),
    });
    return (response?.data?.result ?? []).map(toDraftFaq);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Cannot save FAQs'), {
      cause: error,
    });
  }
}
